import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'
import { BLOCK_OPERATION_DAY_MODAL } from './constants'

export { BLOCK_OPERATION_DAY_MODAL }

const BlockDaysModal = Loadable(() => import('./BlockDaysModal'))

export const createBlockDaysNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'lock',
  text: translateFn('cmd_block_operation_day'),
  identity: BLOCK_OPERATION_DAY_MODAL,
  permission: 'BLOCK_OPER_DAY',
  component: BlockDaysModal,
}))

export default BlockDaysModal
